const $ = require('jquery');

module.exports = function () {
    return {
        restrict: 'A',
        link(scope, elem) {

            const hasTextSelected = function ($target) {
                let _ref;

                if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== $target.prop('selectionEnd')) {
                    return true;
                }
                if (typeof document !== 'undefined' && document !== null) {
                    _ref = document.selection;
                    if (_ref != null ? typeof _ref.createRange === 'function' ? _ref.createRange().text : void 0 : void 0) {
                        return true;
                    }
                }
                return false;
            };

            //Function will allow only number
            const restrictNumeric = function (e) {
                let input;

                if (e.metaKey || e.ctrlKey) {
                    return true;
                }
                if (e.which === 32) {
                    return false;
                }
                if (e.which === 0) {
                    return true;
                }
                if (e.which < 33) {
                    return true;
                }
                input = String.fromCharCode(e.which);
                return !!/[\d\s]/.test(input);
            };

            const restrictDateDDMMYYYY = function (e) {
                let $target, digit, value;

                $target = $(e.currentTarget);
                digit = String.fromCharCode(e.which);
                if (!/^\d+$/.test(digit)) {
                    return true;
                }
                if (hasTextSelected($target)) {
                    return true;
                }
                value = $target.val() + digit;
                value = value.replace(/\D/g, '');
                if (value.length > 8) {
                    return false;
                }
            };

            const formatDateDDMMYYYY = function (e) {
                let $target, digit, oldVal, val;

                digit = String.fromCharCode(e.which);
                if (!/^\d+$/.test(digit)) {
                    return true;
                }
                $target = $(e.currentTarget);
                oldVal = $target.val();
                val = oldVal + digit;
                if (/^\d$/.test(val) && (digit !== '0' && digit !== '1' && digit !== '2' && digit !== '3')) {
                    e.preventDefault();
                    $target.val('0' + val + '/');
                } else if (/^\d{2}$/.test(val)) {
                    e.preventDefault();
                    $target.val('' + val + '/');
                } else if (/^\d{2}\/\d$/.test(val) && (digit !== '0' && digit !== '1')) {
                    e.preventDefault();
                    $target.val('' + oldVal + '0' + digit + '/');
                } else if (/^\d{2}\/\d{2}$/.test(val)) {
                    e.preventDefault();
                    $target.val('' + val + '/');
                }
            };

            const formatForwardSlashDateDDMMYYYY = function (e) {
                let $target, day, month, parseDay, parseMonth, slash, val, _ref;

                slash = String.fromCharCode(e.which);
                if (slash !== '/') {
                    return true;
                }
                $target = $(e.currentTarget);
                val = $target.val();
                parseDay = /^(\d)$/;
                parseMonth = /^(\d{2})\/(\d)$/;
                if (parseDay.test(val) && val !== '0') {
                    $target.val('0' + val + '/');
                } else if (parseMonth.test(val)) {
                    _ref = val.match(parseMonth);
                    day = _ref[1];
                    month = _ref[2];
                    if (month !== '0') {
                        $target.val('' + day + '/0' + month + '/');
                    }
                }
            };

            const formatForwardDateDDMMYYYY = function (e) {
                let $target, digit, val;

                digit = String.fromCharCode(e.which);
                if (!/^\d+$/.test(digit)) {
                    return true;
                }
                $target = $(e.currentTarget);
                val = $target.val();
                if (/^\d{2}$/.test(val) || /^\d{2}\s\/\s\d{2}$/.test(val)) {
                    $target.val('' + val + '/');
                }
            };

            const formatBackDateDDMMYYYY = function (e) {
                let $target, value;

                if (e.meta) {
                    return;
                }
                $target = $(e.currentTarget);
                value = $target.val();
                if (e.which !== 8) {
                    return;
                }
                if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
                    return;
                }
                if (/\d(\s|\/)+$/.test(value)) {
                    e.preventDefault();
                    $target.val(value.replace(/\d(\s|\/)*$/, ''));
                } else if (/\s\/\s?\d?$/.test(value)) {
                    e.preventDefault();
                    $target.val(value.replace(/\s\/\s?\d?$/, ''));
                }
            };

            const formatDDMMYYYY = function () {
                const elm = $(elem);
                elm.on('keypress', restrictNumeric);
                elm.on('keypress', restrictDateDDMMYYYY);
                elm.on('keypress', formatDateDDMMYYYY);
                elm.on('keypress', formatForwardSlashDateDDMMYYYY);
                elm.on('keypress', formatForwardDateDDMMYYYY);
                elm.on('keydown', formatBackDateDDMMYYYY);
            };

            if (!(/Android/i.test(navigator.userAgent))) {
              formatDDMMYYYY();
            }
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/date-validator/date-validator-directive.js
 **/